import { acquireTokenWithRetry } from '@ms/yammer-data/dist/authentication';
import {
  ErrorCode,
  InfoEventName,
  endAndReportPerformanceMeasure,
  reportAuthPageLoad,
  reportError,
  reportInfo,
  startPerformanceMeasure,
} from '@ms/yammer-data/dist/telemetry';
import { PerformanceEventName } from '@ms/yammer-telemetry/dist/performance';
import { isIFrame } from '@ms/yammer-web-support/dist/iframe';
import { getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import { hasMetaOsHubContext } from '@ms/yammer-web-support/dist/metaOsHub';
import config from 'bootstrap/config';
import { writeCookies } from 'bootstrap/cookies';

type AuthBootstrap = () => Promise<void>;
const authBootstrap: AuthBootstrap = async () => {
  let endedWithError = false;
  const measure = startPerformanceMeasure(PerformanceEventName.AuthBootstrap);
  const isExecutingInIFrame = isIFrame();
  const isInTeamsApp = await hasMetaOsHubContext();

  try {
    const yammerToken = await acquireTokenWithRetry([config.adal.resources.yammer]);
    writeCookies(yammerToken);
  } catch (error: unknown) {
    endedWithError = true;

    reportError({
      error,
      eventProperties: {
        errorCode: ErrorCode.AuthBootstrapFailed,
        isInTeamsApp,
        isExecutingInIFrame,
      },
    });

    throw error;
  } finally {
    const urlRootPath = getUrlRootPath(window.location.pathname);

    reportInfo({
      eventName: InfoEventName.AuthBootstrapInfo,
      eventProperties: {
        isExecutingInIFrame,
        isInTeamsApp,
        urlRootPath,
      },
    });

    const eventProperties = { urlRootPath, endedWithError };
    endAndReportPerformanceMeasure({
      ...measure,
      eventProperties,
    });

    reportAuthPageLoad({ eventProperties });
  }

  window.location.reload();
};

export default authBootstrap;
